import React, { useRef, useState, useEffect } from "react";
import {
  // eslint-disable-next-line
  Autocomplete,
  DrawingManager,
  GoogleMap,
  Polygon,
  Rectangle,
  useJsApiLoader,
  Marker,
  KmlLayer,
  InfoWindow 
} from "@react-google-maps/api";
import Button from "react-bootstrap/Button";
import Sidebar from "./Sidebar";
import currentLocationmarker from "../assets/images/marker.png";
import CoordinatesMarker from "../assets/images/coordinatesIcon-marker.png";
import { useNavigate } from "react-router-dom";
//import { useUser } from '../context/UserContext';

const baseUrl = process.env.REACT_APP_API_URL;
const libraries = ["places", "drawing",  'geometry'];
function MapComponent() {
  const mapRef = useRef();
  const polygonRefs = useRef([]);
  const activePolygonIndex = useRef();
  const autocompleteRef = useRef();
  const drawingManagerRef = useRef();
  const kmlLayerRef = useRef(null);
const isPortrait = window.matchMedia("(orientation: portrait)").matches;
  
  const navigate = useNavigate();
  //const { userType } = useUser();

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries,
    version: '3.64' 
  });
  const SQ_KM_TO_SQ_MILES = 0.386102;

  const defaultCenter = {
    lat: 0,
    lng: 0,
  };

  const auth = localStorage.getItem("auth");
  const authJsonObject = JSON.parse(auth);

  const [isDisabled, setIsDisabled] = useState(false);
  const infoWindowRef = useRef(null);
  const [polygons, setPolygons] = useState([]);
  const [center, setCenter] = useState(defaultCenter);
  const [isCaptureCursor, setIsCaptureCursor] = useState(false);
  const [isClickCaptured, setIsClickCaptured] = useState(false);
  const [hoverCoordinates, setHoverCoordinates] = useState(null);
  const [isPopupActive, setIsPopupActive] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(2); 
  const [markerPosition, setMarkerPosition] = useState(null);
  const [CurrentLocationMarkerPosition,setCurrentLocationMarkerPosition]= useState(null);
  const [kmlUrl, setKmlUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [shapeData, setShapeData] = useState(null); 
  const [isMobile, setIsMobile] = useState(false);
  const [areaInfoWindowPosition, setAreaInfoWindowPosition] = useState(null);
const [areaInSqKm, setAreaInSqKm] = useState(0);
const [areaInSqMiles, setAreaInSqMiles] = useState(0);
// eslint-disable-next-line
{isPortrait && (
  <div className="sidebar-country-dropdown">
    <label htmlFor="sidebar-country-select">Select a country:</label>
    <select
      id="sidebar-country-select"
      onChange={(e) =>
        // setKmlUrl(
        //   `https://kmlgenerationgeowgs84.blob.core.windows.net/wourld-country-area-kml-files/${encodeURIComponent(e.target.value)}.kml`
        // )
        setKmlUrl(
          `https://kmlgenerationgeowgs84.blob.core.windows.net/world-country-area-kml-files/${encodeURIComponent(e.target.value)}.kml`
        )
      }
    >
      <option value="">-- Choose a country --</option>
      {Object.entries(require('../assets/countriesJSON/countries.json')).map(
        ([key, label], index) => (
          <option key={index} value={key}>
            {label}
          </option>
        )
      )}
    </select>
  </div>
)}

useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (isLoaded) {
      console.log("Google Maps API is loaded.");
    }
  }, [isLoaded]);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      if (!isLoaded) return;
      try {
        const token = authJsonObject["token"];
        const response = await fetch(`${baseUrl}/currentuser`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const result = await response.json();
  
        if (isMounted && result.profile) {
          // Fetch and display KML file URL
          const kmlUrl = result.profile["geometryfile"];
          if (kmlUrl) {
            setKmlUrl(kmlUrl); // Set the KML file URL state
          }
          // Check if it's the first load
          if (!localStorage.getItem('pageLoaded')) {
            localStorage.setItem('pageLoaded', 'true');
            window.location.reload(); // Force a page refresh
          }
        }
      } catch (error) {
        console.error(error);
        setCenter(defaultCenter); // Use default center on error
      }
    };
  
    fetchData();
    return () => {
      isMounted = false;
    };
  }, [isLoaded]);
  

useEffect(() => {
  if (mapRef.current && center) {
    mapRef.current.setCenter(center);
  }
}, [center]);

  const checkShapes = () => {
    const hasShapes = polygons.length > 0;
    setIsDisabled(!hasShapes);
  };
  useEffect(() => {
    checkShapes();
  }, [polygons]);

  
 const containerStyle = {
  width: "100%",
  height: "100%", // fills its parent: .map-sidebar-container
};
 

  const buttonStyle = {
    position: "absolute",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1, // Ensure button is on top of the map
  };

  const mobileStyle = {
     position: "fixed", // Changed from absolute to fixed for mobile
  bottom: "120px", // Reduced bottom spacing for mobile
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 1000, // Higher z-index for mobile to ensure it's on top
  width: "90%", // Make button wider on mobile
  maxWidth: "300px", // But not too wide
  margin: "0 auto",
  };


  const polygonOptions = {
    strokeColor: "#0000FF", // Blue color for stroke
    strokeOpacity: 1,       // 100% opacity for stroke
    strokeWeight: 2,        // Stroke width
    fillColor: "#0000FF",   // Blue color for fill
    fillOpacity: 0.3,         // 100% transparency for fill
    draggable: false,
    editable: false,
  };

  const rectangleOptions = {
    strokeColor: "#0000FF", // Blue color for stroke
    strokeOpacity: 1,       // 100% opacity for stroke
    strokeWeight: 2,        // Stroke width
    fillColor: "#0000FF",   // Blue color for fill
    fillOpacity: 0.3,         // 100% transparency for fill
    draggable: false,
    editable: false,
  };

  const drawingManagerOptions = {
    polygonOptions: polygonOptions,
    rectangleOptions: rectangleOptions,
    drawingControl: true,
    drawingControlOptions: {
      position: window.google?.maps?.ControlPosition?.TOP_CENTER,
      drawingModes: [
        window.google?.maps?.drawing?.OverlayType?.POLYGON,
        window.google?.maps?.drawing?.OverlayType?.RECTANGLE,
      ],
    },
  };

  const onLoadMap = (map) => {
  mapRef.current = map;

  const isPortrait = window.matchMedia("(orientation: portrait)").matches;

  map.setOptions({
    mapTypeControl: !isPortrait // ✅ show only if NOT portrait
  });

  if (center) {
    map.setCenter(center);
    map.setZoom(zoomLevel);
  }
};


useEffect(() => {
  if (mapRef.current) {
    mapRef.current.setCenter(center);
    mapRef.current.setZoom(zoomLevel);
  }
}, [center]);


  const onLoadPolygon = (polygon, index) => {
    polygonRefs.current[index] = polygon;
  };

  const onClickPolygon = (index) => {
    activePolygonIndex.current = index;
  };

  const onLoadAutocomplete = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };

const onPlaceChanged = () => {
  const place = autocompleteRef.current.getPlace();
  
  if (!place || !place.geometry) {
      console.error("Place or geometry is not defined.");
      return;
  }

  const { geometry } = place;
  const bounds = new window.google.maps.LatLngBounds();

  // Check for viewport or fallback to location
  if (geometry.viewport) {
      bounds.union(geometry.viewport);
  } else if (geometry.location) {
      bounds.extend(geometry.location);
  }

  // Fit the map to the new bounds
  mapRef.current.fitBounds(bounds);
};


const onLoadDrawingManager = (drawingManager) => {
  drawingManagerRef.current = drawingManager;
};


const onOverlayComplete = ($overlayEvent) => {
  setKmlUrl(null); 
  if (kmlLayerRef.current) {
    kmlLayerRef.current.setMap(null); // Remove KML from the map
    kmlLayerRef.current = null; // Clear the reference to the KML layer
  }
  
  // Close any existing area info window
  if (areaInfoWindowPosition) {
    setAreaInfoWindowPosition(null);
  }
  
  // // Clear existing drawings
  const filtered = polygons.filter(
    (polygon, index) => index !== activePolygonIndex.current
  );
  setPolygons(filtered);
  // Clear existing polygons

  let newShape;
  let areaInSqKmValue = 0;
  let areaInSqMilesValue = 0;
  let centerLat = 0;
  let centerLng = 0;

  if ($overlayEvent.type === window.google.maps.drawing.OverlayType.POLYGON) {
    const path = $overlayEvent.overlay.getPath().getArray();
    newShape = {
      type: "polygon",
      paths: path.map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() })),
    };

    // Ensure the polygon is closed
    const startPoint = newShape.paths[0];
    newShape.paths.push(startPoint);
    
    // Calculate area for polygon
    try {
      const areaInSqMeters = window.google.maps.geometry.spherical.computeArea(path);
      areaInSqKmValue = areaInSqMeters / 1e6;
      areaInSqMilesValue = areaInSqKmValue * SQ_KM_TO_SQ_MILES;
      
      // Calculate center of polygon
      let sumLat = 0;
      let sumLng = 0;
      path.forEach(point => {
        sumLat += point.lat();
        sumLng += point.lng();
      });
      centerLat = sumLat / path.length;
      centerLng = sumLng / path.length;
    } catch (error) {
      console.error("Error calculating polygon area:", error);
    }
    
  } else if ($overlayEvent.type === window.google.maps.drawing.OverlayType.RECTANGLE) {
    const bounds = $overlayEvent.overlay.getBounds();
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    newShape = {
      type: "rectangle",
      bounds: [
        { lat: sw.lat(), lng: sw.lng() },
        { lat: ne.lat(), lng: sw.lng() },
        { lat: ne.lat(), lng: ne.lng() },
        { lat: sw.lat(), lng: ne.lng() },
      ],
    };
    
    // Calculate area for rectangle
    try {
      const path = [
        new window.google.maps.LatLng(sw.lat(), sw.lng()),
        new window.google.maps.LatLng(ne.lat(), sw.lng()),
        new window.google.maps.LatLng(ne.lat(), ne.lng()),
        new window.google.maps.LatLng(sw.lat(), ne.lng())
      ];
      const areaInSqMeters = window.google.maps.geometry.spherical.computeArea(path);
      areaInSqKmValue = areaInSqMeters / 1e6;
      areaInSqMilesValue = areaInSqKmValue * SQ_KM_TO_SQ_MILES;
      
      // Calculate center of rectangle
      centerLat = (ne.lat() + sw.lat()) / 2;
      centerLng = (ne.lng() + sw.lng()) / 2;
    } catch (error) {
      console.error("Error calculating rectangle area:", error);
    }
  }

  // Set area info window position and values if area was calculated successfully
  if (areaInSqKmValue > 0 && centerLat !== 0 && centerLng !== 0) {
    setAreaInSqKm(areaInSqKmValue);
    setAreaInSqMiles(areaInSqMilesValue);
    setAreaInfoWindowPosition({ lat: centerLat, lng: centerLng });
  }

  $overlayEvent.overlay?.setMap(null);
  setPolygons([newShape]);

  // Check if newPolygonDataItems is defined correctly before using it
  const newPolygonDataItems =
    newShape.type === "rectangle"
      ? newShape.bounds.map((cord) => [cord.lng, cord.lat])
      : newShape.paths.map((cord) => [cord.lng, cord.lat]);

  if (!newPolygonDataItems) {
    console.error("Invalid polygon data", newShape);
    return;
  }

  const postData = {
    type: "Polygon",
    coordinates: [newPolygonDataItems],
    email: authJsonObject.user["email"],
    newPolygon: newShape,
  };

  // Ready to use Kml generation API
  //generateKml(postData);
  setShapeData(postData);
  drawingManagerRef.current.setDrawingMode(null);
};

  const onEditPolygon = (index) => {
  };

  const handleGenerateKml = async () => {
    setLoading(true); // Show loader
    try {
      if (shapeData) {
        // Call the generate_kml endpoint if shape data is available
        const response = await fetch(`${baseUrl}/generatekml`, {
          method: 'POST',
          body: JSON.stringify(shapeData),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        // const json = await response.json();
        // alert(json.response);
        navigate("/services");
      } else if (kmlUrl) {
        // If no shape data, check if the KML URL is set
        const formData = new FormData();
        formData.append('email', authJsonObject.user.email);
        formData.append('kml_url', kmlUrl); // Use the updated KML URL
        formData.append('user_type', 'provider'); // Ensure userType is set
  
        const response = await fetch(`${baseUrl}/upload_kml`, {
          method: 'POST',
          body: formData,
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        // const json = await response.json();
        // alert(json.response);
        navigate("/services");
      } else {
        console.error("No KML upload or shape data available.");
      }
    } catch (error) {
      console.error("Error generating KML:", error);
    } finally {
      setLoading(false); // Hide loader
    }
  };
  
useEffect(() => {
  const updateMapTypeControl = () => {
    if (mapRef.current) {
      const isPortrait = window.matchMedia("(orientation: portrait)").matches;
      mapRef.current.setOptions({
        mapTypeControl: !isPortrait
      });
    }
  };

  window.addEventListener("resize", updateMapTypeControl);
  return () => window.removeEventListener("resize", updateMapTypeControl);
}, []);

const map = mapRef.current;
useEffect(() => {

  if (isCaptureCursor && map) {
    const handleMouseMove = (e) => {
      if (e.latLng) {
        const latLng = e.latLng;
        setHoverCoordinates({ lat: latLng.lat(), lng: latLng.lng() });
      }
    };

    map.addListener("mousemove", handleMouseMove);

  }
}, [isCaptureCursor]);

const handleMouseMove = (e) => {
  if (isCaptureCursor && e.latLng) {
    const latLng = e.latLng.toJSON();
    setHoverCoordinates(latLng);
  }
};

const handleMapClick = () => {
  // Only capture click if cursor capture is active and not already clicked
  if (isCaptureCursor && !isClickCaptured) {
    setIsClickCaptured(true); // Set click captured flag
    setHoverCoordinates(null); // Reset hover coordinates on click
    handleCloseInfoWindow(); // Close the info window on click
  }
};
const handleCloseInfoWindow = () => {
  setIsCaptureCursor(false);
  setHoverCoordinates(null);
  if (infoWindowRef.current) {
    infoWindowRef.current.close();
  }
};

const handleCursorCapture = () => {
  setIsCaptureCursor((prev) => !prev);
  setIsClickCaptured(false);
  // Toggle popup visibility on icon click
  setIsPopupActive(!isPopupActive);
  if (isCaptureCursor) {
    setHoverCoordinates(null);
  }
};

// FIXED: Updated zoomToDrawnShapes function that works for both KML and drawn shapes
const zoomToDrawnShapes = () => {
  // Check if we have a KML file
  if (mapRef.current && kmlUrl) {
    // Create a KML layer using the KML URL
    const kmlLayer = new window.google.maps.KmlLayer({
      url: kmlUrl,
      map: mapRef.current,
      preserveViewport: false, // Allow the viewport to change based on the KML content
    });

    // Listen for the KML layer to load
    window.google.maps.event.addListenerOnce(kmlLayer, 'defaultviewport_changed', () => {
      const bounds = kmlLayer.getDefaultViewport(); // Get the KML layer's default viewport
      if (bounds) {
        mapRef.current.fitBounds(bounds); // Fit the map to the KML layer's boundaries
        window.google.maps.event.addListenerOnce(mapRef.current, 'idle', () => {
          const boundsCenter = bounds.getCenter();
          const currentZoom = mapRef.current.getZoom();
          const adjustedZoom = currentZoom - 1; 
          mapRef.current.setCenter(boundsCenter);
          mapRef.current.setZoom(adjustedZoom);
        });
      } else {
        console.log("Unable to determine KML bounds.");
      }
    });
  } 
  // Check if we have drawn shapes (polygons/rectangles)
  else if (mapRef.current && polygons.length > 0) {
    // Create bounds from all polygon vertices
    const bounds = new window.google.maps.LatLngBounds();
    
    // Add all polygon points to bounds
    polygons.forEach(shape => {
      if (shape.type === "rectangle") {
        // For rectangles, add all corner points
        shape.bounds.forEach(point => {
          bounds.extend(point);
        });
      } else if (shape.type === "polygon") {
        // For polygons, add all path points
        shape.paths.forEach(point => {
          bounds.extend(point);
        });
      }
    });
    
    // Fit the map to the bounds
    mapRef.current.fitBounds(bounds);
    
    // Optional: Adjust zoom slightly out for better visibility
    window.google.maps.event.addListenerOnce(mapRef.current, 'idle', () => {
      const boundsCenter = bounds.getCenter();
      const currentZoom = mapRef.current.getZoom();
      const adjustedZoom = currentZoom - 1;
      mapRef.current.setCenter(boundsCenter);
      mapRef.current.setZoom(adjustedZoom);
    });
  }
  // If no shapes or KML, check if we have any shape data
  else if (mapRef.current && shapeData && shapeData.newPolygon) {
    // Try to zoom to shape data if available
    const shape = shapeData.newPolygon;
    const bounds = new window.google.maps.LatLngBounds();
    
    if (shape.type === "rectangle" && shape.bounds) {
      shape.bounds.forEach(point => bounds.extend(point));
    } else if (shape.type === "polygon" && shape.paths) {
      shape.paths.forEach(point => bounds.extend(point));
    }
    
    if (!bounds.isEmpty()) {
      mapRef.current.fitBounds(bounds);
      window.google.maps.event.addListenerOnce(mapRef.current, 'idle', () => {
        const boundsCenter = bounds.getCenter();
        const currentZoom = mapRef.current.getZoom();
        const adjustedZoom = currentZoom - 1;
        mapRef.current.setCenter(boundsCenter);
        mapRef.current.setZoom(adjustedZoom);
      });
    }
  } else {
    console.log("No AOI (KML file or drawn shape) found to zoom to.");
  }
};

const handleKmlLayerLoad = () => {
  
  if (kmlUrl) {
    // Remove the previous KML layer if it exists
    if (kmlLayerRef.current) {
      kmlLayerRef.current.setMap(null);
      kmlLayerRef.current = null; // Clear the previous reference to force reload
    }

    // Create and load the new KML layer
    const kmlLayer = new window.google.maps.KmlLayer({
      url: kmlUrl,
      map: mapRef.current,
      preserveViewport: true, // Keep this to prevent zoom changes
    });

    // Store the reference of the new KML layer
    kmlLayerRef.current = kmlLayer;

    // Once the KML is loaded, set the zoom level
    window.google.maps.event.addListener(kmlLayer, 'defaultviewport_changed', () => {
      const bounds = kmlLayer.getDefaultViewport();
      if (bounds) {
        mapRef.current.fitBounds(bounds);
      }
    });
  }
};

useEffect(() => {
  // Remove KML layer if a new shape is drawn
  if (polygons.length > 0 && kmlLayerRef.current) {
    kmlLayerRef.current.setMap(null);
    kmlLayerRef.current = null;
  }
}, [polygons]);

useEffect(() => {
  handleKmlLayerLoad();
}, [kmlUrl]);

const onKMLUpload = async (file) => {
  
  setLoading(true); // Start loading
  setPolygons([])
  const formData = new FormData();
  formData.append('kml_file', file);
  formData.append('user_type', 'provider');

  try {
    const response = await fetch(`${baseUrl}/upload_kml_on_map`, {
      method: 'POST',
      body: formData
    });

    if (response.ok) {
      const data = await response.json();
      setKmlUrl(data.url); 
      //setKmlUploaded(true); // Indicate KML is uploaded
      setIsDisabled(false); // Enable the button
    } else {
      console.error('Failed to upload KML file');
      setIsDisabled(true); // Keep the button disabled
    }
  } catch (error) {
      console.error('Error uploading KML file:', error);
      setIsDisabled(true); // Keep the button disabled
  } finally {
      setLoading(false); // End loading
  }
};

const CountrySelectKmlUrl = (url) => {
  setPolygons([])
  setKmlUrl(url);
  setIsDisabled(false); // Enable the button after selecting the country and setting the URL
};

useEffect(() => {
  // Enable button if either KML URL or shapeData is available
  if (kmlUrl || shapeData) {
    setIsDisabled(false);  // Enable button
  } else {
    setIsDisabled(true);  // Disable button
  }
}, [kmlUrl, shapeData]);  // Run effect when kmlUrl or shapeData changes


return isLoaded ? (
  <div className="map-sidebar-container" >
    {!isPortrait && (
  <div className="sidebar">
    <Sidebar
      setCenter={setCenter}
      setCaptureCoordinates={handleCursorCapture}
      setZoomLevel={setZoomLevel}
      zoomToDrawnShapes={zoomToDrawnShapes}
      setMarkerPosition={setMarkerPosition}
      setCurrentLocationMarkerPosition={setCurrentLocationMarkerPosition}
      setKmlUrl={CountrySelectKmlUrl}
      onKMLUpload={onKMLUpload}
      onLoadAutocomplete={onLoadAutocomplete}
      onPlaceChanged={onPlaceChanged}
    />
  </div>
)}

{!isPortrait && (
  <div style={{
    position: "absolute",
    top: "10px",
    right: "10px",
    zIndex: 10,
    width: "300px"
  }}>
    <Autocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged}>
      <input
        type="text"
        placeholder="Search Location"
        style={{
          width: "100%",
          height: "40px",
          padding: "0 12px",
          fontSize: "16px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
        }}
      />
    </Autocomplete>
  </div>
)}


{window.matchMedia("(orientation: portrait)").matches && (
  <div className="mobile-country-dropdown">
    <label htmlFor="country-select">Select a country:</label>
    <select
      id="country-select"
      onChange={(e) =>
        // setKmlUrl(
        //   `https://kmlgenerationgeowgs84.blob.core.windows.net/wourld-country-area-kml-files/${encodeURIComponent(e.target.value)}.kml`
        // )
        setKmlUrl(
          `https://kmlgenerationgeowgs84.blob.core.windows.net/world-country-area-kml-files/${encodeURIComponent(e.target.value)}.kml`
        )
      }
    >
      <option value="">-- Choose a country --</option>
      {Object.entries(require('../assets/countriesJSON/countries.json')).map(
        ([key, label], index) => (
          <option key={index} value={key}>{label}</option>
        )
      )}
    </select>
  </div>
)}

      <GoogleMap
        zoom={zoomLevel}
        center={center}
        onLoad={onLoadMap}
        mapContainerStyle={containerStyle}
              onClick={handleMapClick}
  onMouseMove={handleMouseMove}
        onTilesLoaded={() => setCenter(null)}
      >
     {markerPosition && (
  <Marker
    position={markerPosition}
    icon={CoordinatesMarker} // Optional: Use a custom icon for the marker
  />
    )}
      {CurrentLocationMarkerPosition && (
  <Marker
    position={CurrentLocationMarkerPosition}
    icon={currentLocationmarker} // Optional: Use a custom icon for the marker
  />
    )}
            {isPopupActive && hoverCoordinates && (
        <InfoWindow
          position={hoverCoordinates}
          onCloseClick={handleCloseInfoWindow}
        >
          <div>
            <p>
              Latitude: {hoverCoordinates.lat.toFixed(6)}
            </p>
            <p>
              Longitude: {hoverCoordinates.lng.toFixed(6)}
            </p>
            {/* Add optional reverse geocoding functionality here */}
          </div>
        </InfoWindow>
      )}
        <DrawingManager
          onLoad={onLoadDrawingManager}
          onOverlayComplete={onOverlayComplete}
          options={drawingManagerOptions}
        />
        {polygons.map((shape, index) => {
          if (shape.type === "rectangle") {
            return (
              <Rectangle
                key={index}
                onLoad={(event) => onLoadPolygon(event, index)}
                onMouseDown={() => onClickPolygon(index)}
                onMouseUp={() => onEditPolygon(index)}
                onDragEnd={() => onEditPolygon(index)}
                options={rectangleOptions}
                bounds={
                  new window.google.maps.LatLngBounds(
                    shape.bounds[0],
                    shape.bounds[2]
                  )
                }
                draggable
                editable
              />
            );
          } else {
            return (
              <Polygon
                key={index}
                onLoad={(event) => onLoadPolygon(event, index)}
                onMouseDown={() => onClickPolygon(index)}
                onMouseUp={() => onEditPolygon(index)}
                onDragEnd={() => onEditPolygon(index)}
                options={polygonOptions}
                paths={shape.paths}
                draggable
                editable
              />
            );
          }
        })}
      
        {kmlUrl && (
                      <KmlLayer
                       url={kmlUrl}
                       options={{ preserveViewport: false }}
                       />
                     )}
                      {areaInfoWindowPosition && (
    <InfoWindow
        position={areaInfoWindowPosition}
        onCloseClick={() => {
            setAreaInfoWindowPosition(null);
            setAreaInSqKm(0);
            setAreaInSqMiles(0);
        }}
    >
        <div style={{ position: 'relative', padding: '12px 16px', minWidth: '180px' }}>
           
            <div style={{ marginTop: '8px' }}>
                <strong style={{ fontSize: '14px' }}>Area of Interest</strong>
                
                <p style={{ margin: '5px 0', fontSize: '13px' }}>
                    <strong>{areaInSqKm.toFixed(2)} sq km</strong>
                </p>
            </div>
        </div>
    </InfoWindow>
)}
      </GoogleMap>
{/* <Button 
      onClick={handleGenerateKml} 
      disabled={isDisabled} 
      style={isMobile ? mobileStyle : buttonStyle} 
      className="btn btn-primary"
    >
      Go to Step-2 <br/>
      (Please Select Services you provide)
    </Button> */}
    <Button 
  onClick={handleGenerateKml} 
  // Disable if manually disabled OR if the API is currently working
  disabled={isDisabled || loading} 
  style={isMobile ? mobileStyle : buttonStyle} 
  className="btn btn-primary"
>
  {loading ? (
    <div className="d-flex align-items-center justify-content-center">
      <span 
        className="spinner-border spinner-border-sm me-2" 
        role="status" 
        aria-hidden="true"
      ></span>
      <span>Processing...</span>
    </div>
  ) : (
    <>
      Go to Step-2 <br/>
      (Please Select Services you provide)
    </>
  )}
</Button>
      
    </div>
 ):  
  null;
  }
export { MapComponent };